<template>
    <div class="session__show">
        <div class="session__show_header">
            <div class="container">
                <div class="columns is-block-mobile is-variable">
                    <div class="column">
                        <div class="session__show_header_details">
                            <div class="columns is-variable">
                                <div class="column">
                                    <a
                                        class="session__show_hiddenlink hidden"
                                    ></a>
                                    <view-actions
                                        ref="viewactions"
                                        :title="sessionDates"
                                        :size="'small'"
                                        :breadcrumb-active="user.isEventCoordinator() || user.isInfrastructureManager() || user.isTrainer() || (user.isLearner() && !customerOptionsHideEventsCatalogue)"
                                        :breadcrumb-items="[
                                            {
                                                name: $t('ebs.sessions.show.name.events'),
                                                to: { name: 'ebs-event-list' }
                                            },
                                            {
                                                name: sessionEventName,
                                                to: sessionEventPath
                                            }
                                        ]"
                                        :notify-title="$t('ebs.sessions.show.name.session')"
                                        :notify-process="$t('ebs.sessions.show.notify.sessionCancel')"
                                        :status-active="true"
                                        :status-visibility="['event_coordinator', 'infrastructure_admin']"
                                        :status-name="sessionStatus"
                                        :trash-button-active="sessionAllowEdit && sessionAllowRemove"
                                        :trash-button-visibility="['event_coordinator']"
                                        :cancel-button-active="true"
                                        :cancel-button-text="$t('ebs.sessions.show.buttons.printFlyer')"
                                        :cancel-notify-active="false"
                                        :custom-button-active="sessionAllowCancelSession"
                                        :custom-button-danger="true"
                                        :custom-notify-active="true"
                                        :custom-button-text="$t('ebs.sessions.show.text.cancelSession')"
                                        :custom-notify-title="$t('ebs.sessions.show.title.cancelSession')"
                                        :custom-notify-text="sessionCancelNotifyDescription"
                                        :custom-notify-cancel-text="$t('ebs.sessions.show.buttons.dismiss')"
                                        :custom-notify-custom-active="true"
                                        :custom-notify-custom-text="$t('ebs.sessions.show.text.cancelSession')"
                                        :custom-notify-custom-danger="true"
                                        :custom-notify-submit-active="Boolean(rawSessionSimilarSessions.length) && sessionHasBookedLearnersActive"
                                        :custom-notify-submit-text="$t('ebs.sessions.show.text.cancelSessionAnd')"
                                        :custom-notify-submit-danger="true"
                                        :custom-notify-submit-animate-loading="false"
                                        :custom-notify-size="Boolean(rawSessionSimilarSessions.length && sessionHasBookedLearnersActive) ? 'big' : 'normal'"
                                        :custom-notify-prevent-close="true"
                                        :submit-button-text="isSessionUpcoming || isSessionInProgress || isSessionDraft ? 'Edit session' : 'View settings'"
                                        :trash-notify-prevent-close="true"
                                        :action-button-visibility="['event_coordinator']"
                                        @emit-notify-custom-custom="sessionCancel"
                                        @emit-notify-custom-submit="openSessionCancelTransferNotify"
                                        @emit-notify-remove-submit="sessionRemove"
                                        @emit-cancel="sessionPrintFlyer"
                                        @emit-custom="getSessionSimilarSessions"
                                        @emit-submit="sessionEdit"
                                    />
                                </div>
                            </div>
                            <template v-if="sessionDescription">
                                <div class="session__show_header_details_description" v-html="sessionDescription"></div>
                            </template>
                        </div>
                    </div>
                    <template v-if="sessionEventImages.length">
                        <div class="column is-narrow">
                            <div class="session__show_header_image">
                                <component-slider
                                    :images="sessionEventImages"
                                    :alt="sessionEventName"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="session__show_main">
            <div class="container">
                <session-show-tabs/>
            </div>
        </div>
        <pop-notify
            :class="'pop__notify--cancelledexpiredusers'"
            :title-text="'Session cancelled'"
            :content-text="'Some already booked learners will be expired and will not attend on the session: \n'"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-active="false"
            ref="sessioncancelledexpiredusers"
            @emit-close="clearExpiredUsers"
        >
            <component-text-list :size="'small'" :color="'dark-gray'" :items="expiredUsers"></component-text-list>
        </pop-notify>
        <pop-notify
            :class="'pop__notify--modifiedexpiredusers'"
            :title-text="'Session modified'"
            :content-text="'Some already booked learners will be expired and will not attend on the session: \n'"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-active="false"
            ref="sessionmodifiedexpiredusers"
            @emit-close="clearExpiredUsers"
        >
            <component-text-list :size="'small'" :color="'dark-gray'" :items="expiredUsers"></component-text-list>
        </pop-notify>
        <pop-notify
            :class="'pop__notify--archiveunable'"
            :title-text="$t('ebs.sessions.show.notify.unableToArchiveSession')"
            :content-text="$t('ebs.sessions.show.notify.unableToArchiveSessionText')"
            :cancel-button-text="$t('ebs.sessions.show.notify.close')"
            :submit-button-active="false"
            ref="sessionremovepop"
        />
        <pop-table
            ref="sessioncanceltransfer"
            :item-name="['session', 'sessions']"
            :class="'session__show_transferbookingtable'"
            :title-text="$t('ebs.sessions.show.table.transferBooking')"
            :content-text="$t('ebs.sessions.show.table.selectSession')"
            :cancel-button-text="$t('ebs.sessions.show.table.close')"
            :submit-button-text="$t('ebs.sessions.show.table.confirm')"
            :filter-search-by-field="'dates'"
            :items="sessionSimilarSessionsTableMappedIdDatesRoomsTrainersSpaces"
            :labels="[
                {
                    key: 'dates',
                    title: 'Dates',
                    type: 'date',
                    sortable: true
                },
                {
                    key: 'rooms',
                    title: 'Locations',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'trainers',
                    title: 'Trainers',
                    type: 'string',
                    sortable: true
                },
                {
                    key: 'availableSpaces',
                    title: 'Available spaces',
                    type: 'number',
                    sortable: true
                }
            ]"
            :table-checkbox="true"
            :prevent-close="true"
            :eventbus-emit-name="'session-transfer-bookings'"
            :size="'full'"
            :allow-single="true"
            @emit-submit="sessionCancelTransfer"
        />
    </div>
</template>

<script>
import SessionShowTabs from '@/components/ebs/sessions/show/SessionShowTabs'
import ViewActions from '@/components/default/shared/ViewActions'
import PopNotify from '@/components/default/shared/PopNotify'
import PopTable from '@/components/default/shared/PopTable'
import ComponentSlider from '@/components/default/shared/ComponentSlider'
import { User } from '@/User'
import ComponentTextList from "@/components/default/shared/ComponentTextList";

export default {
  components: {
    ComponentTextList,
    ComponentSlider,
    PopTable,
    PopNotify,
    ViewActions,
    SessionShowTabs
  },
  data () {
    return {
      user: new User()
    }
  },
  name: 'session-show',
  computed: {
    isSessionDraft () {
      return this.sessionStatus === 'draft'
    },
    isSessionUpcoming () {
      return this.sessionStatus === 'upcoming'
    },
    isSessionInProgress () {
      return this.sessionStatus === 'in_progress'
    },
    eventId: function () {
      return this.$route.params.id
    },
    session: function () {
      return this.$store.getters.getSession
    },
    sessionEventId: function () {
      return this.$route.params.eventId
    },
    sessionEventName: function () {
      return this.$store.getters.getEventName
    },
    sessionEventPath: function () {
      return { name: 'ebs-event-show', params: { id: this.$route.params.eventId } }
    },
    sessionEventImages: function () {
      return this.$store.getters.getEventImage.map(image => {
        return image.imageId
      })
    },
    sessionDates: function () {
      return this.$store.getters.getSessionDates
    },
    sessionDescription: function () {
      return this.$store.getters.getEventDescription
    },
    sessionId: function () {
      return this.$store.getters.getSessionId
    },
    sessionStatus: function () {
      return this.$store.getters.getSessionStatus
    },
    sessionAllowEdit: function () {
      return this.$store.getters.getSessionAllowEdit
    },
    sessionAllowRemove: function () {
      return this.$store.getters.getSessionAllowRemove
    },
    sessionAllowCancelSession () {
      return this.$store.getters.getSessionAllowCancelSession
    },
    rawSessionSimilarSessions () {
      return this.$store.getters.getSessionSimilarSessions
    },
    sessionSimilarSessionsTableMappedIdDatesRoomsTrainersSpaces () {
      return this.$store.getters.getSessionSimilarSessionsMappedIdDatesRoomsTrainersSpaces
    },
    sessionHasBookedLearnersActive () {
      return this.$store.getters.getSessionHasBookedLearnersActive
    },
    sessionCancelNotifyDescription () {
      let hasBookings = this.sessionHasBookedLearnersActive
      let hasSessions = this.rawSessionSimilarSessions.length
      let description

      if (hasBookings && hasSessions) {
        description = this.$t('ebs.sessions.show.description.permanentlyCancelLong')
      } else if (hasBookings && !hasSessions) {
        description = this.$t('ebs.sessions.show.description.permanentlyCancelMedium')
      } else {
        description = this.$t('ebs.sessions.show.description.permanentlyCancelShort')
      }

      return description
    },
    customerOptionsHideEventsCatalogue () {
      return this.$store.getters.getDefaultCustomerOptionsHideEventsCatalogue
    },
    expiredUsers () {
      return this.$store.getters.getSessionCustomExpiredUsers
    }
  },
  methods: {
    getSessionSimilarSessions () {
      if (this.rawSessionSimilarSessions.length) return
      this.$store.dispatch('getSessionSimilarSessions', this.sessionId)
    },
    //
    openSessionCancelTransferNotify () {
      this.$refs.sessioncanceltransfer.openPop()
    },
    openSessionCancelledExpiredUsers () {
      this.$refs.sessioncancelledexpiredusers.openNotify()
    },
    openSessionModifiedExpiredUsers () {
      this.$refs.sessionmodifiedexpiredusers.openNotify()
    },
    closeSessionCancelTransferNotify () {
      if (this.$refs.sessioncanceltransfer && this.$refs.sessioncanceltransfer.isActive) {
        this.$refs.sessioncanceltransfer.closePop()
      }
    },
    closeSessionCancelNotify () {
      if (this.$refs.viewactions.$refs.popnotifycustom && this.$refs.viewactions.$refs.popnotifycustom.isActive) {
        this.$refs.viewactions.$refs.popnotifycustom.closeNotify()
      }
    },
    //
    sessionEdit: function () {
      this.$router.push({ name: 'ebs-session-edit', params: { sessionId: this.sessionId } })
    },
    sessionRemove: function () {
      const sessionId = this.$route.params.sessionId
      this.$store.dispatch('removeSession', sessionId).finally(() => {
        this.$refs.viewactions.$refs.popnotifyremove.closeNotify()
      })
    },
    sessionCancel () {
      const sessionId = this.sessionId
      this.$store.dispatch('cancelSession', [sessionId])
    },
    sessionCancelTransfer (data) {
      const similarSessionId = data[0].id
      const sessionId = this.sessionId
      
      this.$store.dispatch('cancelSession', [sessionId, similarSessionId]).then(response => {
        if (this.expiredUsers && this.expiredUsers.length) {
          this.openSessionCancelledExpiredUsers()
        }
      })
    },
    sessionPrintFlyer () {
      this.$store.dispatch('printSessionFlyer', this.sessionId)
    },
    clearExpiredUsers () {
      this.$store.dispatch('setSessionCustomExpiredUsers', [])
    }
  },
  watch: {
    sessionId () {
      this.closeSessionCancelNotify()
      this.closeSessionCancelTransferNotify()
    }
  },
  mounted () {
    if (this.expiredUsers && this.expiredUsers.length) {
      this.openSessionModifiedExpiredUsers()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionshow";
</style>
